function applyTranslations(t: Record<string, any>) {
  const elements = document.querySelectorAll<HTMLElement>("[data-i18n]");

  // MAIN TRANSLATIONS attr=data-i18n
  elements.forEach((element) => {
    const key = element.getAttribute("data-i18n");
    const translation = getNestedTranslation(t, key);

    if (translation !== undefined) {
      // Handle newlines in text (convert \n to <br/>)
      if (typeof translation === "string" && translation.includes("\n")) {
        element.innerHTML = translation.replace(/\n/g, "<br/>");
      } else {
        element.textContent = translation;
      }
    }
  });

  // PLACEHOLDERS attr=data-i18n-placeholder
  const placeholderElements = document.querySelectorAll
    <HTMLInputElement>("[data-i18n-placeholder]");
  placeholderElements.forEach((element) => {
    const key = element.getAttribute("data-i18n-placeholder");
    const translation = getNestedTranslation(t, key);

    if (translation !== undefined && element.placeholder !== undefined) {
      element.placeholder = translation;
    }
  });

  // PAGE TITLE
  const titleElement = document.querySelector("title[data-i18n]");
  if (titleElement) {
    const key = titleElement.getAttribute("data-i18n");
    const translation = getNestedTranslation(t, key);
    if (translation !== undefined) {
      document.title = translation;
    }
  }
}

function getNestedTranslation(obj: Record<string, any>, path: string | null): any {
  if (!path) return undefined;
  
  return path.split(".").reduce((current, key) => {
    return current && current[key] !== undefined ? current[key] : undefined;
  }, obj);
}

export { applyTranslations };
